<div class="table-card gaps-card" [class.open]="open">

  <div class="table-header-bar">
    <button type="button" class="gaps-toggle" id="cashgapstoggle" [attr.aria-expanded]="open" (click)="toggle()"
      matTooltipPosition="above" [matTooltip]="open ? '' : 'Afficher les écarts de caisse : fond de caisse à la clôture contre fond à l\'ouverture, fond compté au Z contre espèces attendues'">
      <mat-icon class="chevron">{{ open ? 'expand_less' : 'expand_more' }}</mat-icon>
      <mat-icon>rule</mat-icon>
      <span>Écarts de caisse</span>
    </button>
    <span class="rh-tag" matTooltip="Visible avec l'habilitation Responsable RH seulement">RH</span>
    @if (open) {
      <span class="scope" matTooltip="Le magasin se règle dans la barre de l'onglet, la caisse dans le filtre « Caisse » de la carte">{{ scopeLabel }}</span>
      @if (windowLabel) {
        <span class="window">{{ windowLabel }}</span>
      }
      <div class="card-actions">
        <button mat-stroked-button type="button" class="btn-card" id="exportgapsbutton" (click)="exportCsv()"
          [disabled]="!canExport" matTooltip="Écarts listés (nuits et journées) en fichier .csv (Excel)">
          <mat-icon>download</mat-icon>
          Exporter
        </button>
      </div>
    }
  </div>

  @if (open) {
    <div class="gaps-filters">
      <div class="filter-item date-filter" id="gaps-from">
        <app-select-date label="Du" [date]="from ?? undefined" (dateChange)="fromChange($event)"></app-select-date>
      </div>
      <div class="filter-item date-filter" id="gaps-to">
        <app-select-date label="Au" [date]="to ?? undefined" (dateChange)="toChange($event)"></app-select-date>
      </div>
      <div class="filter-item">
        <span class="filter-label">Raccourcis</span>
        <div class="quick">
          <button mat-stroked-button type="button" class="btn-card" id="gaps-week" (click)="lastWeek()">7 derniers jours</button>
          <button mat-stroked-button type="button" class="btn-card" id="gaps-month" (click)="thisMonth()">Mois en cours</button>
          <button mat-stroked-button type="button" class="btn-card" id="gaps-last-month" (click)="lastMonth()">Mois précédent</button>
        </div>
      </div>
      <div class="filter-item">
        <label class="filter-label" for="gaps-station">Caisse</label>
        <select id="gaps-station" class="custom-select station-select" [ngModel]="station" (ngModelChange)="setStation($event)">
          <option [ngValue]="null">Toutes</option>
          @for (s of stationOpts; track s.id) {
            <option [ngValue]="s.id">{{ s.label }}</option>
          }
        </select>
      </div>
      <div class="filter-item">
        <label class="filter-label" for="gaps-person">Personne</label>
        <select id="gaps-person" class="custom-select person-select" [ngModel]="person" (ngModelChange)="setPerson($event)">
          <option [ngValue]="null">Toutes</option>
          @for (p of people; track p.id) {
            <option [ngValue]="p.id">{{ personLabel(p) }}</option>
          }
        </select>
      </div>
      <div class="filter-item">
        <span class="filter-label">&nbsp;</span>
        <mat-checkbox id="gaps-only" class="gaps-only" [checked]="gapsOnly" (change)="setGapsOnly($event.checked)"
          matTooltip="Décoché : les comptages et les inventaires justes aussi">Écarts seulement</mat-checkbox>
      </div>
      <div class="filter-actions">
        <button mat-stroked-button type="button" class="btn-inline btn-ghost" aria-label="Actualiser les écarts" title="Recharger" (click)="load()">
          <mat-icon [class.spinning]="loading">refresh</mat-icon>
        </button>
      </div>
    </div>

    @if (error) {
      <div class="load-error"><mat-icon>error_outline</mat-icon><span>Écarts de caisse illisibles : {{ error }}</span></div>
    }

    @if (data) {
      <div class="gaps-section">
        <div class="section-title">
          <mat-icon>point_of_sale</mat-icon>
          <span>Journée : espèces attendues au Z, tiroir compté</span>
          <span class="badge-count">{{ days.length }}</span>
          <span class="formula">Attendu = fond à l'ouverture + espèces encaissées + reçu − dépôt au coffre · Écart = compté − attendu</span>
        </div>
        <table class="grid days">
          <thead>
            <tr>
              <th matTooltip="Jour de la journée de caisse">Jour</th>
              <th matTooltip="Caisse de la journée (son magasin en dessous quand le magasin est « Tous »)">Caisse</th>
              <th matTooltip="Personne qui a ouvert la journée et compté le fond, avec l'heure">Ouverture par</th>
              <th class="num" matTooltip="Fond compté par la personne qui a ouvert la journée">Fond à l'ouverture</th>
              <th class="num" matTooltip="Espèces encaissées au comptoir sur cette caisse, de l'ouverture au Z, rendus de monnaie déduits ; survol : chaque encaissement">
                <span class="op">+</span>&nbsp;Espèces encaissées
              </th>
              <th class="num" matTooltip="Espèces reçues d'un coffre ou d'un autre poste pendant la journée (approvisionnement) ; survol : le détail">
                <span class="op">+</span>&nbsp;Reçu
              </th>
              <th class="num" matTooltip="Enveloppes déposées au coffre pendant la journée (et toute autre sortie de la caisse : remise en banque, transfert vers un autre poste, signalée au survol) ; survol : heures et montants">
                <span class="op">−</span>&nbsp;Dépôt au coffre
              </th>
              <th class="num" matTooltip="Espèces attendues dans le tiroir, figées au moment du Z : fond + espèces encaissées + reçu − dépôt au coffre">
                <span class="op">=</span>&nbsp;Attendu
              </th>
              <th matTooltip="Ont encaissé des espèces au comptoir ou fait un mouvement d'espèces de la caisse pendant la journée">Espèces manipulées par</th>
              <th matTooltip="Personne qui a fait le Z et compté le tiroir, avec l'heure">Z par</th>
              <th class="num" matTooltip="Espèces comptées dans le tiroir au Z">Compté</th>
              <th class="num" matTooltip="Compté − attendu : négatif = manque, positif = excédent">Écart</th>
            </tr>
          </thead>
          <tbody>
            @for (d of days; track d.period_id) {
              <tr [class]="'st-' + d.status">
                <td class="c-day">{{ d.text.day }}</td>
                <td class="wrap">{{ stationLabel(d.station, d.station_name) }}@if (store === null) { <span class="sub">{{ storeLabel(d.store, d.store_name) }}</span> }</td>
                <td class="wrap">
                  @if (d.opened_by !== null) {
                    {{ nameOf(d.opened_by, d.opened_by_name) }}
                  } @else {
                    <span class="none" matTooltip="Ouverture sans fond compté : son auteur n'est pas conservé avec la journée">inconnu</span>
                  }
                  <span class="sub">{{ d.text.start }}</span>
                </td>
                <td class="num">@if (d.opening_amount !== null) { {{ d.opening_amount | fc }} € } @else { <span class="none" [matTooltip]="hints.unreliable">non compté</span> }</td>
                <td class="num"><ng-container [ngTemplateOutlet]="amount" [ngTemplateOutletContext]="{ $implicit: d.cash_payments, peek: d.cashPeek }"></ng-container></td>
                <td class="num"><ng-container [ngTemplateOutlet]="amount" [ngTemplateOutletContext]="{ $implicit: d.transfers_in, peek: d.inPeek }"></ng-container></td>
                <td class="num"><ng-container [ngTemplateOutlet]="amount" [ngTemplateOutletContext]="{ $implicit: d.transfers_out, peek: d.outPeek }"></ng-container></td>
                <td class="num c-expected">
                  @if (d.drift) {
                    <mat-icon class="warn drift" tabindex="0" role="img" aria-hidden="false" [matTooltip]="driftHint(d)" [attr.aria-label]="driftHint(d)">warning_amber</mat-icon>
                  }
                  {{ d.expected | fc }} €
                </td>
                <td class="wrap c-handlers">
                  @for (h of d.handlers; track h.id; let last = $last) { {{ personLabel(h) }}@if (!last) {, } } @empty { <span class="none">personne</span> }
                </td>
                <td class="wrap">{{ nameOf(d.id_user, d.user_name) }} <span class="sub">{{ d.text.counted }}</span></td>
                <td class="num">{{ d.amount | fc }} €</td>
                <ng-container [ngTemplateOutlet]="gapCell" [ngTemplateOutletContext]="{ $implicit: d.gap, status: d.status }"></ng-container>
              </tr>
            } @empty {
              <tr><td colspan="12" class="empty">{{ gapsOnly && dayTotals?.counts ? 'Aucun écart au Z sur la période' : 'Aucun Z compté sur la période' }}</td></tr>
            }
          </tbody>
          @if (dayTotals && dayTotals.counts) {
            <tfoot>
              <tr>
                <td colspan="9">{{ totalsLabel(dayTotals, 'comptage', 'non significatif') }}</td>
                <td colspan="3" class="num"><ng-container [ngTemplateOutlet]="gapFoot" [ngTemplateOutletContext]="{ $implicit: dayTotals }"></ng-container></td>
              </tr>
            </tfoot>
          }
        </table>
      </div>

      <div class="gaps-section">
        <div class="section-title">
          <mat-icon>bedtime</mat-icon>
          <span>Nuit : fond laissé à la clôture, trouvé à l'ouverture</span>
          <span class="badge-count">{{ nights.length }}</span>
          <span class="formula">Attendu = fond de caisse à la clôture ± mouvements caisse clôturée · Écart = trouvé − attendu</span>
        </div>
        <table class="grid nights">
          <thead>
            <tr>
              <th matTooltip="Jour de l'ouverture : la nuit qui la précède">Matin du</th>
              <th matTooltip="Caisse ouverte (son magasin en dessous quand le magasin est « Tous »)">Caisse</th>
              <th matTooltip="Personne qui a fait la dernière clôture de cette caisse avant l'ouverture, avec le jour et l'heure">Clôture de caisse</th>
              <th class="num" matTooltip="Espèces comptées dans le tiroir à cette clôture et laissées pour la nuit, avec le jour et l'heure du comptage">Fond de caisse à la clôture</th>
              <th class="num" matTooltip="Espèces entrées (+, approvisionnement depuis le coffre…) ou sorties (−, dépôt au coffre ou en banque) pendant que la caisse était clôturée, entre la clôture et l'ouverture ; normalement 0 ; survol : le détail">
                <span class="op">±</span>&nbsp;Mouvements caisse clôturée
              </th>
              <th class="num" matTooltip="Fond attendu à l'ouverture, figé à ce moment : fond de caisse à la clôture ± mouvements caisse clôturée">
                <span class="op">=</span>&nbsp;Attendu
              </th>
              <th matTooltip="Personne qui a ouvert la journée et compté le fond, avec l'heure">Ouverture par</th>
              <th class="num" matTooltip="Fond compté à l'ouverture">Trouvé</th>
              <th class="num" matTooltip="Trouvé − attendu : négatif = manque, positif = excédent">Écart</th>
            </tr>
          </thead>
          <tbody>
            @for (n of nights; track n.period_id) {
              <tr [class]="'st-' + n.status">
                <td class="c-day">{{ n.text.day }}</td>
                <td class="wrap">{{ stationLabel(n.station, n.station_name) }}@if (store === null) { <span class="sub">{{ storeLabel(n.store, n.store_name) }}</span> }</td>
                <td class="wrap">
                  @if (n.ref_period_id !== null) {
                    {{ nameOf(n.ref_user, n.ref_user_name) }} <span class="sub">{{ n.text.refClosed }}</span>
                  } @else {
                    <span class="none">aucune clôture avant</span>
                  }
                </td>
                <td class="num">
                  @if (n.ref_amount !== null) {
                    {{ n.ref_amount | fc }} €
                    @if (n.ref_counted_at) { <span class="sub">compté le {{ n.text.refCounted }}</span> }
                  } @else if (n.ref_period_id !== null) { <span class="none" [matTooltip]="hints.unknown">non compté</span> }
                </td>
                <td class="num c-closed">
                  @if (n.closedNet === null) {
                    <span class="none">—</span>
                  } @else if (n.closedPeek; as p) {
                    <span class="peek-anchor" tabindex="0" [class.neg]="n.closedNet < 0" [class.pos]="n.closedNet > 0" [attr.aria-label]="peekLabel(p)"
                      (mouseenter)="showPeek($event, p)" (mouseleave)="leavePeek($event)" (focus)="showPeek($event, p)" (blur)="blurPeek($event)" (keydown)="peekKey($event)">{{ signed(n.closedNet) }} €</span>
                  } @else {
                    <span [class.zero]="!n.closedNet">{{ n.closedNet | fc }} €</span>
                  }
                </td>
                <td class="num c-expected">@if (n.expected !== null) { {{ n.expected | fc }} € } @else { <span class="none">—</span> }</td>
                <td class="wrap">{{ nameOf(n.id_user, n.user_name) }} <span class="sub">{{ n.text.counted }}</span></td>
                <td class="num">{{ n.amount | fc }} €</td>
                <ng-container [ngTemplateOutlet]="gapCell" [ngTemplateOutletContext]="{ $implicit: n.gap, status: n.status }"></ng-container>
              </tr>
            } @empty {
              <tr><td colspan="9" class="empty">{{ gapsOnly && nightTotals?.counts ? 'Aucun écart de nuit sur la période' : 'Aucune ouverture comptée sur la période' }}</td></tr>
            }
          </tbody>
          @if (nightTotals && nightTotals.counts) {
            <tfoot>
              <tr>
                <td colspan="6">{{ totalsLabel(nightTotals, 'comptage', 'incalculable') }}</td>
                <td colspan="3" class="num"><ng-container [ngTemplateOutlet]="gapFoot" [ngTemplateOutletContext]="{ $implicit: nightTotals }"></ng-container></td>
              </tr>
            </tfoot>
          }
        </table>
      </div>

      <!-- Absente sans l'habilitation Coffres-forts : le serveur rend alors envelopes à null. -->
      @if (data.envelopes !== null) {
        <div class="gaps-section envelopes-section">
          <div class="section-title">
            <mat-icon>lock</mat-icon>
            <span>Enveloppes versées au coffre</span>
            <span class="badge-count">{{ envelopes.length }}</span>
            <span class="rh-tag" matTooltip="Visible avec l'habilitation Coffres-forts seulement">Coffres-forts</span>
            <div class="card-actions">
              <button mat-stroked-button type="button" class="btn-card" id="exportenvelopesbutton" (click)="exportEnvelopesCsv()"
                [disabled]="!envelopes.length" matTooltip="Enveloppes listées en fichier .csv (Excel)">
                <mat-icon>download</mat-icon>
                Exporter
              </button>
            </div>
          </div>
          <table class="grid envelopes">
            <thead>
              <tr>
                <th matTooltip="Jour et heure du dépôt au coffre">Date</th>
                <th matTooltip="Caisse d'où viennent les espèces (son magasin en dessous quand le magasin est « Tous »)">Depuis</th>
                <th matTooltip="Personne qui a fait le dépôt au coffre">Par</th>
                <th matTooltip="Coffre qui a reçu l'enveloppe">Coffre</th>
                <th class="num">Montant</th>
                <th class="num" matTooltip="Solde du coffre juste après ce dépôt">Solde du coffre après</th>
              </tr>
            </thead>
            <tbody>
              @for (e of envelopes; track e.id) {
                <tr>
                  <td class="c-day">{{ e.text.day }} <span class="clock">{{ e.text.clock }}</span></td>
                  <td class="wrap">{{ stationLabel(e.source, e.source_name) }}@if (store === null) { <span class="sub">{{ storeLabel(e.source_store, e.source_store_name) }}</span> }</td>
                  <td class="wrap">{{ nameOf(e.id_user, e.user_name) }}</td>
                  <td class="wrap">{{ strongboxLabel(e.destination, e.destination_name) }}</td>
                  <td class="num c-amount">{{ e.amount | fc }} €</td>
                  <td class="num">@if (e.destination_balance !== null) { {{ e.destination_balance | fc }} € } @else { <span class="none">—</span> }</td>
                </tr>
              } @empty {
                <tr><td colspan="6" class="empty">Aucun dépôt au coffre sur la période</td></tr>
              }
            </tbody>
            @if (envelopes.length) {
              <tfoot>
                <tr>
                  <td colspan="4">{{ envelopes.length }} enveloppe{{ envelopes.length > 1 ? 's' : '' }}</td>
                  <td class="num">{{ envelopesTotal | fc }} €</td>
                  <td></td>
                </tr>
              </tfoot>
            }
          </table>
        </div>
      }

      <!-- Toujours là : l'écart d'un inventaire se lit sans l'habilitation Coffres-forts, ses montants non. -->
      <div class="gaps-section strongbox-counts-section">
        <div class="section-title">
          <mat-icon>inventory_2</mat-icon>
          <span matTooltip="Inventaires faits dans les coffres-forts du magasin sur la période. Le filtre « Personne » et la case « Écarts seulement » s'y appliquent, pas le filtre « Caisse ». Solde théorique et compté réservés à l'habilitation Coffres-forts ; l'écart est toujours visible.">Inventaires des coffres-forts</span>
          <span class="badge-count">{{ strongboxCounts.length }}</span>
          <span class="formula">Écart = compté − solde théorique juste avant l'inventaire</span>
          <div class="card-actions">
            <button mat-stroked-button type="button" class="btn-card" id="exportstrongboxcountsbutton" (click)="exportStrongboxCountsCsv()"
              [disabled]="!strongboxCounts.length" matTooltip="Inventaires listés en fichier .csv (Excel)">
              <mat-icon>download</mat-icon>
              Exporter
            </button>
          </div>
        </div>
        <table class="grid strongbox-counts">
          <thead>
            <tr>
              <th matTooltip="Jour et heure de l'inventaire">Date</th>
              <th matTooltip="Coffre compté (son magasin en dessous quand le magasin est « Tous »)">Coffre</th>
              <th matTooltip="Personne qui a fait l'inventaire">Par</th>
              <th class="num" matTooltip="Solde théorique du coffre juste avant l'inventaire">Solde théorique</th>
              <th class="num" matTooltip="Espèces comptées dans le coffre : nouveau point de départ de son solde">Compté</th>
              <th class="num" matTooltip="Compté − solde théorique : négatif = manque, positif = excédent">Écart</th>
            </tr>
          </thead>
          <tbody>
            @for (c of strongboxCounts; track c.id) {
              <tr>
                <td class="c-day">{{ c.text.day }} <span class="clock">{{ c.text.clock }}</span></td>
                <td class="wrap">{{ strongboxLabel(c.station, c.station_name) }}@if (store === null) { <span class="sub">{{ storeLabel(c.store, c.store_name) }}</span> }</td>
                <td class="wrap">{{ nameOf(c.id_user, c.user_name) }}</td>
                <td class="num">@if (c.expected !== null) { {{ c.expected | fc }} € } @else { <span class="none reserved" [matTooltip]="reservedHint">—</span> }</td>
                <td class="num">@if (c.amount !== null) { {{ c.amount | fc }} € } @else { <span class="none reserved" [matTooltip]="reservedHint">—</span> }</td>
                <ng-container [ngTemplateOutlet]="gapCell" [ngTemplateOutletContext]="{ $implicit: c.gap, status: c.status }"></ng-container>
              </tr>
            } @empty {
              <tr><td colspan="6" class="empty">{{ gapsOnly && strongboxCountTotals.counts ? 'Aucun écart d\'inventaire de coffre-fort sur la période' : 'Aucun inventaire de coffre-fort sur la période' }}</td></tr>
            }
          </tbody>
          @if (strongboxCountTotals.counts) {
            <tfoot>
              <tr>
                <td colspan="3">{{ totalsLabel(strongboxCountTotals, 'inventaire') }}</td>
                <td colspan="3" class="num"><ng-container [ngTemplateOutlet]="gapFoot" [ngTemplateOutletContext]="{ $implicit: strongboxCountTotals }"></ng-container></td>
              </tr>
            </tfoot>
          }
        </table>
      </div>
    }
  }

</div>

<!-- Montant d'une colonne de calcul : souligné en pointillé et survolable quand il a un détail, gris discret à 0. -->
<ng-template #amount let-v let-p="peek">
  @if (p) {
    <span class="peek-anchor" tabindex="0" [attr.aria-label]="peekLabel(p)"
      (mouseenter)="showPeek($event, p)" (mouseleave)="leavePeek($event)" (focus)="showPeek($event, p)" (blur)="blurPeek($event)" (keydown)="peekKey($event)">{{ v | fc }} €</span>
  } @else {
    <span [class.zero]="!v">{{ v | fc }} €</span>
  }
</ng-template>

<!-- Cellule d'écart des trois tableaux : juste en gris, manque en rouge, excédent en vert avec « + » ; incalculable (nuit) et non significatif (Z) avec leur infobulle. -->
<ng-template #gapCell let-v let-status="status">
  @switch (status) {
    @case ('unknown') { <td class="num c-gap uncertain" [matTooltip]="hints.unknown">inconnu</td> }
    @case ('unreliable') { <td class="num c-gap uncertain" [matTooltip]="hints.unreliable"><mat-icon class="warn">warning_amber</mat-icon>{{ signed(v) }} €</td> }
    @case ('ok') { <td class="num c-gap ok">{{ v | fc }} €</td> }
    @default { <td class="num c-gap" [class.neg]="v < 0" [class.pos]="v > 0">{{ signed(v) }} € <span class="gap-kind">{{ v < 0 ? 'manque' : 'excédent' }}</span></td> }
  }
</ng-template>

<!-- Pied des trois tableaux : manque et excédent sommés à part, jamais compensés. -->
<ng-template #gapFoot let-t>
  <span class="neg">manque {{ t.shortage | fc }} €</span> · <span class="pos">excédent {{ signed(t.excess) }} €</span>
</ng-template>

<!-- Fenêtre de survol, rendue par le CDK Overlay hors de la carte ; colonnes selon sa sorte (PEEK_COLUMNS), corps défilant (focalisable : un clic le garde ouvert, les flèches le font défiler), pied toujours visible. -->
<ng-template #peekPanel>
  @if (peek; as p) {
    <div class="peek-panel" [id]="peekId" role="tooltip" tabindex="-1" (mouseleave)="leavePeek($event)" (focusout)="blurPeek($event)">
      <div class="peek-head">
        <span class="peek-title">{{ p.title }}</span>
        <span class="peek-context">{{ p.context }}</span>
      </div>
      @if (p.lines.length) {
        <div class="peek-scroll" tabindex="0" role="region" [attr.aria-label]="p.title">
          <table class="peek-lines" [class.peek-payments]="p.sort === 'payments'">
            <thead>
              <tr>
                @for (c of peekColumns[p.sort]; track c.label) { <th [class.num]="c.num">{{ c.label }}</th> }
              </tr>
            </thead>
            <tbody>
              @if (p.sort === 'moves') {
                @for (l of p.lines; track l.id) {
                  <tr>
                    <td class="when">{{ l.when }}</td>
                    <td class="num" [class.neg]="l.amount < 0">{{ l.amount | fc }} €</td>
                    <td class="way">{{ l.way }} {{ l.other }} @if (l.kind) { <span class="kind" [class.bank]="l.kind === 'banque'">{{ l.kind }}</span> }</td>
                    <td class="by">{{ l.by }}</td>
                  </tr>
                }
              } @else {
                @for (l of p.lines; track l.id) {
                  <tr>
                    <td class="when">{{ l.when }}</td>
                    <td class="num" [class.neg]="l.amount < 0">{{ l.amount | fc }} €</td>
                    <td>@if (l.tagged) { <span class="kind">{{ l.nature }}</span> } @else { {{ l.nature }} }</td>
                    <td class="customer">{{ l.customer }}</td>
                    <td class="orders">{{ l.orders }}</td>
                    <td class="by">{{ l.by }}</td>
                  </tr>
                }
              }
            </tbody>
            <tfoot>
              <tr>
                <td>Total</td>
                <td class="num" [class.neg]="p.total < 0">{{ p.total | fc }} €</td>
                <td [attr.colspan]="peekColumns[p.sort].length - 2">{{ p.note }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      } @else {
        <div class="peek-note">{{ p.note }}</div>
        <div class="peek-total"><span>Total</span><span class="num">{{ p.total | fc }} €</span></div>
      }
    </div>
  }
</ng-template>
